import { userProfileItems } from 'global/components/user/userProfileItems';
import _ from 'lodash';
import { useContext, useMemo } from 'react';
import { ParentContext } from '../ParentContext';
import { useAppUserAccess } from './useAppUserAccess';

export const useProfileItems = () => {

  const appUserAccess = useAppUserAccess()
  const { loggedIn } = appUserAccess ?? {}

  const parentContexts = useContext(ParentContext)
  const { states, fns } = parentContexts ?? {}
  const {
    appUser_state,
    paps_state,
    currentSettings_state,
  } = states ?? {}

  const { appUser_fns } = fns
  const { appUser } = appUser_state ?? {}
  const { pathViews, view, viewKey } = paps_state ?? {}

  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, showAppUserPersonalPages, showAppUserProfilePages, showAppUserPrivacyPages, groupAppUserPages, showProfileSettingsAsPublic } = aps_appUserSettings ?? {}
  const _showAppUserPages = showAppUserPersonalPages || showAppUserProfilePages || showAppUserPrivacyPages

  const getAppUserProfileItems = () => {
    let pis = {};
    if (appUserCollection === view && (_showAppUserPages)) {
      const aaua = appUser_fns.validateAccess_appUser({ pathViews, appUserCollection, view, viewKey, appUserAccess })
      if (showProfileSettingsAsPublic || aaua) {
        pis = userProfileItems(aps_global, aps_appUserSettings, appUser)
      }
    } else if (view === 'clients' && loggedIn) {
      // appUserSwipeItems(pis)
    }
    return pis
  }

  const prfItems = useMemo(() => getAppUserProfileItems(), [
    _showAppUserPages,
    appUser,
    appUserAccess,
    appUserCollection,
    aps_appUserSettings,
    aps_global,
    groupAppUserPages,
    loggedIn,
    pathViews,
    showProfileSettingsAsPublic,
    view,
  ]);

  return { prfItems };

}


